import "core-js/modules/es.array.push.js";
import { reactive, ref, getCurrentInstance, onMounted, onUnmounted, onBeforeUnmount, nextTick } from "vue";
import SvgIcon from "../components/SvgIcon.vue";
import util from "@/util/util";
import { genFileId, ElLoading } from "element-plus";
import { useRouter, useRoute } from "vue-router";
import useClipboard from "vue-clipboard3";
import permission from "@/util/permission";
import store from "../store";
import cookies from "js-cookie";
import { DownCircleOutlined, PlusOutlined, ExclamationCircleOutlined } from "@ant-design/icons-vue";
import { useI18n } from "vue-i18n";

import { ElNotification, ElMessageBox, ElMessage } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/notification/style/css';
import 'element-plus/es/components/message-box/style/css';
import 'element-plus/es/components/message/style/css';
export default {
  name: "InstallPlan",
  components: {
    SvgIcon,
    DownCircleOutlined
  },
  setup() {
    const {
      t,
      locale
    } = useI18n();
    const {
      proxy
    } = getCurrentInstance();
    const {
      toClipboard
    } = useClipboard();
    const router = useRouter();
    const route = useRoute();
    const activityId = route.params.activityId;
    const vendorId = route.params.vendorId;
    const tokenData = util.getToken();
    let installConveyData = {};
    try {
      installConveyData = JSON.parse(cookies.get("installConvey_" + activityId));
    } catch {}
    const importMessage = reactive({
      importMessageVisible: false,
      importMessages: []
    });
    const reportChecks = ref([]);
    const deliveredControl = reactive({
      allChecked: false,
      isOpenBatch: false,
      isOpenReport: false
    });
    const activeName = ref("first");
    const uploadInstallPane = ref(null);
    const installTable = ref();
    // 分页
    const installPaginationData = reactive({
      pageSizes: [25, 50, 100],
      currentPage: 1,
      totalSize: 0,
      pageSize: 25
    });

    // 安装进度列表
    const cityData = reactive([]);
    const provinceDictData = reactive([]);
    const activityData = reactive([]);
    const storeTypeData = reactive([]);
    const storeTypeInstallationData = reactive([]);
    const storeTypeLogisticsData = reactive([]);
    const vendorData = reactive([]);
    const vendorTypeData = reactive([]);
    const installationStatusData = reactive([]);
    const getInstallationConfirmData = reactive([]);
    const installationData = reactive({
      data: []
    });
    const uploadInstallData = reactive({
      signatureData: {
        accessId: null,
        policy: null,
        signature: null,
        dir: null,
        host: "",
        expire: null,
        uuid: null
      },
      fileList: [],
      data: {},
      lastUpload: {},
      cacheData: []
    });
    const uploadInstallPopoverVisible = ref(false);
    const installQuery = reactive({
      typeIndex: 1,
      insValue: "",
      insSelect: {
        storeType: null,
        vendorId: null,
        vendorTypeId: null,
        installationStatusId: null,
        installationResultId: null,
        provinceCity: null,
        areaInput: null,
        installationConfirmStatusId: null,
        activityId: null
      }
    });
    //分页Select变化
    const paginationSizeInstallChange = val => {
      let data = {
        installationResultId: installQuery.insSelect.installationResultId,
        installationStatusId: installQuery.insSelect.installationStatusId,
        searchKeyword: installQuery.insValue,
        storeType: installQuery.insSelect.storeType,
        vendorId: installQuery.insSelect.vendorId,
        activityId: installQuery.insSelect.activityId,
        vendorTypeId: installQuery.insSelect.vendorTypeId,
        installationConfirmStatusId: installQuery.insSelect.installationConfirmStatusId
      };
      if (Array.isArray(installQuery.insSelect.provinceCity)) {
        data.province = installQuery.insSelect.provinceCity[0];
        if (installQuery.insSelect.provinceCity.length > 1) {
          data.city = installQuery.insSelect.provinceCity[1];
        }
      }
      getInstallationPageApi(data, installPaginationData.currentPage, installPaginationData.pageSize);
    };
    //分页页数变化
    const paginationCurrentInstallChange = val => {
      let data = {
        installationResultId: installQuery.insSelect.installationResultId,
        installationStatusId: installQuery.insSelect.installationStatusId,
        searchKeyword: installQuery.insValue,
        storeType: installQuery.insSelect.storeType,
        vendorId: installQuery.insSelect.vendorId,
        activityId: installQuery.insSelect.activityId,
        vendorTypeId: installQuery.insSelect.vendorTypeId,
        installationConfirmStatusId: installQuery.insSelect.installationConfirmStatusId
      };
      if (Array.isArray(installQuery.insSelect.provinceCity)) {
        data.province = installQuery.insSelect.provinceCity[0];
        if (installQuery.insSelect.provinceCity.length > 1) {
          data.city = installQuery.insSelect.provinceCity[1];
        }
      }
      getInstallationPageApi(data, installPaginationData.currentPage, installPaginationData.pageSize);
    };
    //btn点击事件
    const openUploadInstallPopover = () => {
      uploadInstallPane.value.clearFiles();
      uploadInstallPopoverVisible.value = true;
    };
    //当超出限制时，执行的钩子函数
    const handleInstallExceed = files => {
      uploadInstallPane.value.clearFiles();
      const file = files[0];
      file.uid = genFileId();
      uploadInstallPane.value.handleStart(file);
      uploadInstallPane.value.submit();
    };
    //获取文件签名等信息
    const getSignature = async directory => {
      console.log(directory);
      return new Promise((resolve, reject) => {
        proxy.$api.authorizationRequest.getSignature(directory).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          console.log(error);
          reject(error);
        });
      });
    };
    //上传文件之前的钩子
    const handleInstallBeforeUpload = async file => {
      uploadInstallData.signatureData = await getSignature("__temporary");
      let filename = file.name;
      let fullName = uploadInstallData.signatureData.uuid + util.getSuffix(filename);
      let keyValue = uploadInstallData.signatureData.dir + fullName;
      uploadInstallData.data = {
        name: file.name,
        key: keyValue,
        policy: uploadInstallData.signatureData.policy,
        OSSAccessKeyId: uploadInstallData.signatureData.accessId,
        signature: uploadInstallData.signatureData.signature,
        success_action_status: "200",
        onSuccess: file.uid
      };
      uploadInstallData.lastUpload = {
        uid: file.uid,
        filename: fullName
      };
    };
    //文件上传成功的钩子
    const handleInstallOnSuccess = async (response, file, files) => {
      if (file.status === "success") {
        let activityUploadedRO = {
          activityId: activityId,
          uploadedRO: {
            fileName: uploadInstallData.data.name,
            uploadedName: uploadInstallData.data.key
          }
        };
        importInstallationRequest(activityUploadedRO);
      }
    };
    const importInstallationRequest = async activityUploadedRO => {
      const loadingInstance = ElLoading.service({
        lock: true,
        text: t("installConvey.importingBatchInstall"),
        background: "rgba(0, 0, 0, 0.7)"
      });
      proxy.$api.activityRequest.importInstallation(activityUploadedRO).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "202163") {
            uploadInstallPopoverVisible.value = false;
            ElNotification({
              title: "success",
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "success",
              duration: 3000
            });
          } else if (res.result.dataCode === "202177") {
            uploadInstallPopoverVisible.value = false;
            importMessage.importMessageVisible = true;
            importMessage.importMessages = res.result.data;
          } else {
            ElNotification({
              title: t("installConvey.failure"),
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "error",
              duration: 6000
            });
          }
        } else {
          ElNotification({
            title: t("installConvey.failure"),
            message: res.msg,
            type: "error",
            duration: 6000
          });
        }
        nextTick(() => {
          loadingInstance.close();
        });
      }).catch(error => {
        ElNotification({
          title: "error",
          message: error,
          type: "error",
          duration: 3000
        });
        nextTick(() => {
          loadingInstance.close();
        });
      });
    };
    const installLoading = ref(false);
    //时间戳转时间
    const getDate = data => {
      let date = new Date(data); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + "-";
      let M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-";
      let D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      let h = (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      let m = (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) + ":";
      let s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    };
    //表头排序
    const headerCellInstallClickEvent = ({
      column,
      triggerResizable,
      triggerSort,
      triggerFilter
    }) => {
      const $table = installTable.value;
      if ($table) {
        // 如果触发了列的其他功能按钮
        if (column.sortable && !(triggerResizable || triggerSort || triggerFilter)) {
          if (column.order === "desc") {
            $table.clearSort();
          } else if (column.order === "asc") {
            $table.sort(column.field, "desc");
          } else {
            $table.sort(column.field, "asc");
          }
        }
      }
    };
    //获取安装进度列表
    const getInstallationPageApi = async (data, pageIndex, pageSize, add) => {
      installLoading.value = true;
      let logisticsPageRO = {
        data: data,
        pageIndex: pageIndex,
        pageSize: pageSize
      };
      window.localStorage.setItem("installation_page_param", JSON.stringify(logisticsPageRO));
      let callApi = proxy.$api.scheduleRequest.getInstallationPage;
      if (vendorId == "" && tokenData.type === 1) {
        callApi = proxy.$api.scheduleRequest.getStoreInstallationPage;
      }
      callApi(logisticsPageRO).then(async res => {
        console.log(res);
        if (res.code === "200000") {
          if (res.result.dataCode === "202250") {
            let msg = res.result.data.pageList;
            if (msg) {
              for (let install of msg) {
                const uniqueStoreLocations = install.storeLocations.reduce((accumulator, current) => {
                  const existingObject = accumulator.find(item => item.installationResponsibleName === current.installationResponsibleName);
                  if (!existingObject) {
                    accumulator.push(current);
                  }
                  return accumulator;
                }, []);
                install.activityInstallations = uniqueStoreLocations;
              }
              if (add) {
                installationData.data.push(...msg);
                installPaginationData.totalSize = res.result.data.totalCount;
              } else {
                installationData.data = msg;
                installPaginationData.totalSize = res.result.data.totalCount;
              }
              // nextTick(() => {
              //   const rowsToCheck = installationData.data.filter((row) =>
              //     reportChecks.includes(row.storeCode)
              //   );
              //   rowsToCheck.forEach((row) => {
              //     installTable.value.setCheckboxRow(row, true);
              //   });
              // });
            } else {
              installationData.data = msg;
              installPaginationData.totalSize = res.result.data.totalCount;
            }
          } else {
            ElNotification({
              title: t("installConvey.failure"),
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "error",
              duration: 3000
            });
          }
        } else {
          ElNotification({
            title: t("installConvey.failure"),
            message: res.msg,
            type: "error",
            duration: 3000
          });
        }
        installLoading.value = false;
      }).catch(error => {
        if (error.code == "TOKEN_MISSING") {
          console.log(error);
        } else {
          ElNotification({
            title: t("installConvey.failure"),
            message: error,
            type: "error",
            duration: 3000
          });
        }
        installLoading.value = false;
      });
    };
    const openInstallationEvent = () => {
      let installationPageRO = {
        installationResultId: installQuery.insSelect.installationResultId,
        installationStatusId: installQuery.insSelect.installationStatusId,
        searchKeyword: installQuery.insValue,
        activityId: installQuery.insSelect.activityId,
        storeType: installQuery.insSelect.storeType,
        vendorId: installQuery.insSelect.vendorId,
        vendorTypeId: installQuery.insSelect.vendorTypeId
      };
      if (Array.isArray(installQuery.insSelect.provinceCity)) {
        installationPageRO.province = installQuery.insSelect.provinceCity[0];
        if (installQuery.insSelect.provinceCity.length > 1) {
          installationPageRO.city = installQuery.insSelect.provinceCity[1];
        }
      }
      getInstallationExport(installationPageRO);
    };
    const onCheckboxChange = ({
      row,
      checked
    }) => {
      const key = row.storeCode;
      if (checked) {
        if (!reportChecks.value.includes(key)) {
          reportChecks.value.push(key);
        }
      } else {
        reportChecks.value = reportChecks.value.filter(k => k !== key);
      }
    };
    const onCheckboxAll = ({
      records
    }) => {
      const newKeys = records.map(row => row.storeCode);
      reportChecks.value = Array.from(new Set([...reportChecks.value, ...newKeys]));
    };
    const changeReport = () => {
      if (deliveredControl.isOpenReport == false) {
        deliveredControl.isOpenReport = true;
      } else {
        const $table = installTable.value;
        if ($table) {
          if (reportChecks.value.length > 0) {
            const activityInstallationReportRO = {
              activityId: activityId,
              storeCodes: reportChecks.value
            };
            getInstallationReportPdf(activityInstallationReportRO);
          }
          deliveredControl.isOpenReport = false;
          $table.clearCheckboxRow();
          $table.clearCheckboxReserve();
          reportChecks.value.length = 0;
        }
      }
    };
    const getInstallationReportPdf = activityInstallationReportRO => {
      const loadingInstance = ElLoading.service({
        lock: true,
        text: t("installConvey.exportingPDF"),
        background: "rgba(0, 0, 0, 0.7)"
      });
      proxy.$api.scheduleRequest.getInstallationReportPdf(activityInstallationReportRO).then(res => {
        nextTick(() => {
          loadingInstance.close();
        });
      }).catch(error => {
        ElNotification({
          title: t("activityDetail.error"),
          message: error,
          type: "error",
          duration: 3000
        });
        nextTick(() => {
          loadingInstance.close();
        });
      });
    };
    const getInstallationExport = installationPageRO => {
      const loadingInstance = ElLoading.service({
        lock: true,
        text: t("installConvey.exportingTemplate"),
        background: "rgba(0, 0, 0, 0.7)"
      });
      proxy.$api.scheduleRequest.getInstallationExport(installationPageRO).then(res => {
        nextTick(() => {
          loadingInstance.close();
        });
      }).catch(error => {
        ElNotification({
          title: "error",
          message: error,
          type: "error",
          duration: 3000
        });
        nextTick(() => {
          loadingInstance.close();
        });
      });
    };
    // 获取所有店铺城市
    const getStoreCity = async storeCityRO => {
      return new Promise((resolve, reject) => {
        proxy.$api.storeRequest.getStoreCity(storeCityRO, true).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: t("installConvey.failure"),
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const getProvinceDict = async storeActivityVendorRO => {
      return new Promise((resolve, reject) => {
        proxy.$api.storeRequest.getProvinceDictByActivity(storeActivityVendorRO, true).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: t("installConvey.failure"),
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    // 获取所有店铺省份
    const getStoreProvince = async activityId => {
      return new Promise((resolve, reject) => {
        proxy.$api.storeRequest.getStoreProvince(activityId, true).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: t("installConvey.failure"),
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    // 获取所有店铺类型
    const getStoreType = async () => {
      return new Promise((resolve, reject) => {
        proxy.$api.storeRequest.getStoreType(true).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: t("installConvey.failure"),
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const getStoreTypeByInstallation = async storeActivityVendorRO => {
      return new Promise((resolve, reject) => {
        proxy.$api.storeRequest.getStoreTypeByInstallation(storeActivityVendorRO, true).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: t("installConvey.failure"),
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const getStoreTypeByLogistics = async storeActivityVendorRO => {
      return new Promise((resolve, reject) => {
        proxy.$api.storeRequest.getStoreTypeByLogistics(storeActivityVendorRO, true).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: t("installConvey.failure"),
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    // 获取所有供应商
    const getVendor = async () => {
      return new Promise((resolve, reject) => {
        proxy.$api.vendorRequest.getVendorAll(true).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: t("installConvey.failure"),
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    // 获取所有供应商类型
    const getVendorType = async () => {
      return new Promise((resolve, reject) => {
        proxy.$api.vendorRequest.getVendorType(true).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: t("installConvey.failure"),
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };

    // 获取所有安装状态
    const getInstallationStatus = async () => {
      return new Promise((resolve, reject) => {
        proxy.$api.scheduleRequest.getInstallationStatus(true).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: t("installConvey.failure"),
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };

    // 获取所有验收状态
    const getInstallationConfirm = async () => {
      return new Promise((resolve, reject) => {
        proxy.$api.repairRequest.getInstallationResult(true).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: t("installConvey.failure"),
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const selectAllActivity = async () => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityRequest.selectAllActivity(true).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: t("installConvey.failure"),
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };

    //搜索点击事件
    const searchInstallClick = async linkageType => {
      let storeActivityVendorRO = {
        activityId: installQuery.insSelect.activityId,
        vendorId: installQuery.insSelect.vendorId,
        storeTypeId: installQuery.insSelect.storeType
      };
      if (linkageType === 1) {
        provinceDictData.length = 0;
        // 获取活动相关所有省份
        var provinceDictList = await getProvinceDict(storeActivityVendorRO);
        if (provinceDictList == null) {
          return;
        } else {
          provinceDictList = provinceDictList.map(provinceItem => ({
            value: provinceItem.province,
            label: provinceItem.province,
            children: provinceItem.cities.map(cityItem => ({
              value: cityItem.city,
              label: cityItem.city
            }))
          }));
        }
        provinceDictData.push(...provinceDictList);
      } else if (linkageType === 2) {
        if (Array.isArray(installQuery.insSelect.provinceCity)) {
          storeActivityVendorRO.province = installQuery.insSelect.provinceCity[0];
          if (installQuery.insSelect.provinceCity.length > 1) {
            storeActivityVendorRO.city = installQuery.insSelect.provinceCity[1];
          }
        }
        storeTypeInstallationData.length = 0;
        // 获取指定活动安装所有店铺类型
        let storeTypeInstallationList = await getStoreTypeByInstallation(storeActivityVendorRO);
        if (storeTypeInstallationList == null) {
          return;
        }
        storeTypeInstallationData.push(...storeTypeInstallationList);
      }
      let data = {
        installationResultId: installQuery.insSelect.installationResultId,
        installationStatusId: installQuery.insSelect.installationStatusId,
        searchKeyword: installQuery.insValue,
        activityId: installQuery.insSelect.activityId,
        storeType: installQuery.insSelect.storeType,
        vendorId: installQuery.insSelect.vendorId,
        vendorTypeId: installQuery.insSelect.vendorTypeId,
        installationConfirmStatusId: installQuery.insSelect.installationConfirmStatusId
      };
      if (Array.isArray(installQuery.insSelect.provinceCity)) {
        data.province = installQuery.insSelect.provinceCity[0];
        if (installQuery.insSelect.provinceCity.length > 1) {
          data.city = installQuery.insSelect.provinceCity[1];
        }
      }
      installPaginationData.currentPage = 1;
      const $table = installTable.value;
      $table.clearCheckboxRow();
      $table.clearCheckboxReserve();
      reportChecks.value.length = 0;
      deliveredControl.isOpenReport = false;
      getInstallationPageApi(data, 1, installPaginationData.pageSize);
    };
    // 店铺信息复制
    const copyStore = async row => {
      let text = t("installConvey.address") + "：" + row.storeAddress + "\n" + t("installConvey.contact") + "：" + row.storeContactName + "\n" + t("installConvey.phone") + "：" + row.storeContactMobile;
      console.log(text);
      try {
        await toClipboard(text); //实现复制
        console.log("Success");
        ElNotification({
          title: "success",
          message: t("installConvey.copyToClipboard"),
          type: "success",
          duration: 3000
        });
      } catch (e) {
        console.error(e);
      }
    };
    // 供应商信息复制
    const copyVendor = async row => {
      let text = "";
      if (Array.isArray(row.activityInstallations)) {
        for (let install of row.activityInstallations) {
          text += t("installConvey.contact") + "：" + install.installationResponsibleName + "\n" + t("installConvey.phone") + "：" + row.phoneNumber;
        }
      }
      console.log(text);
      try {
        await toClipboard(text); //实现复制
        console.log("Success");
        ElNotification({
          title: "success",
          message: t("installConvey.copyToClipboard"),
          type: "success",
          duration: 3000
        });
      } catch (e) {
        console.error(e);
      }
    };
    // 验收信息复制
    const copyResult = async row => {
      let text = t("installConvey.contact") + "：" + row.installationResultContactName + "\n" + t("installConvey.phone") + "：" + row.installationResultContactMobile;
      console.log(text);
      try {
        await toClipboard(text); //实现复制
        console.log("Success");
        ElNotification({
          title: "success",
          message: t("installConvey.copyToClipboard"),
          type: "success",
          duration: 3000
        });
      } catch (e) {
        console.error(e);
      }
    };
    const installTableScroll = ({
      type,
      scrollTop,
      scrollLeft,
      scrollHeight,
      scrollWidth,
      bodyWidth,
      bodyHeight,
      isX,
      isY,
      $event
    }) => {
      let mediaQuery = window.matchMedia("(max-width: 768px)");
      if (mediaQuery.matches) {
        if (scrollTop + bodyHeight >= scrollHeight - 20) {
          let totalCount = Math.ceil(installPaginationData.totalSize / installPaginationData.pageSize);
          console.log("-------------------" + installPaginationData.currentPage < totalCount);
          if (installPaginationData.currentPage < totalCount) {
            installPaginationData.currentPage++;
            let data = {
              installationResultId: installQuery.insSelect.installationResultId,
              installationStatusId: installQuery.insSelect.installationStatusId,
              searchKeyword: installQuery.insValue,
              storeType: installQuery.insSelect.storeType,
              vendorId: installQuery.insSelect.vendorId,
              vendorTypeId: installQuery.insSelect.vendorTypeId
            };
            if (Array.isArray(installQuery.insSelect.provinceCity)) {
              data.province = installQuery.insSelect.provinceCity[0];
              if (installQuery.insSelect.provinceCity.length > 1) {
                data.city = installQuery.insSelect.provinceCity[1];
              }
            }
            getInstallationPageApi(data, installPaginationData.currentPage, installPaginationData.pageSize, "add");
          }
        }
      }
    };
    const goConveyPlan = () => {
      if (vendorId) {
        router.push({
          path: "/convey-plan/" + activityId + "/" + vendorId
        });
      } else {
        router.push({
          path: "/convey-plan/" + activityId
        });
      }
    };
    const TENCENT_MAP_KEY = "O7CBZ-SEBY4-3X7U3-KIN5U-J5UK5-AXBDP";
    const TENCENT_MAP_SK = "cVzMbavR2kccR1Pa5NqxsBM7zL3A862m";
    const TENCENT_ROUTE_PATH = "/ws/direction/v1/driving";
    const TENCENT_ROUTE_PROXY_PREFIX = "/qqmap-ws";
    var map = null;
    var qqMaps = null;
    var routeOverlays = [];
    const isUsableTencentMapsApi = mapsApi => {
      return !!(mapsApi && typeof mapsApi.Map === "function" && typeof mapsApi.LatLng === "function" && typeof mapsApi.Marker === "function" && typeof mapsApi.Polyline === "function");
    };
    const clearRouteOverlays = () => {
      routeOverlays.forEach(overlay => {
        if (overlay && typeof overlay.setMap === "function") {
          overlay.setMap(null);
        }
      });
      routeOverlays = [];
    };
    const destroyExpressMap = () => {
      clearRouteOverlays();
      map = null;
      const container = document.getElementById("container");
      if (container) {
        container.innerHTML = "";
      }
    };
    const loadTencentMapSdk = () => {
      if (isUsableTencentMapsApi(qqMaps)) {
        return Promise.resolve(qqMaps);
      }
      if (isUsableTencentMapsApi(window.qq && window.qq.maps)) {
        qqMaps = window.qq.maps;
        return Promise.resolve(window.qq.maps);
      }
      if (window.__qqMapSdkPromise) {
        return window.__qqMapSdkPromise;
      }
      window.__qqMapSdkPromise = new Promise((resolve, reject) => {
        const maxWaitMs = 10000;
        const checkIntervalMs = 100;
        const startAt = Date.now();
        const checkMapsApi = () => {
          const mapsApi = window.qq && window.qq.maps;
          if (isUsableTencentMapsApi(mapsApi)) {
            qqMaps = mapsApi;
            resolve(mapsApi);
            return;
          }
          if (Date.now() - startAt >= maxWaitMs) {
            window.__qqMapSdkPromise = null;
            reject(new Error("Tencent Map SDK was not ready after waiting 10000ms. window.qq keys: " + Object.keys(window.qq || {}).join(",") + "; window.qq.maps keys: " + Object.keys(window.qq && window.qq.maps || {}).join(",")));
            return;
          }
          window.setTimeout(checkMapsApi, checkIntervalMs);
        };
        checkMapsApi();
      });
      return window.__qqMapSdkPromise;
    };
    const parseCoordinateToLatLng = (coordinate, mapsApi) => {
      if (!coordinate) {
        return null;
      }
      const parts = coordinate.split(",").map(Number);
      if (parts.length < 2 || parts.some(item => Number.isNaN(item))) {
        return null;
      }
      return createMapsObject(mapsApi, "LatLng", parts[0], parts[1]);
    };
    const createMapsObject = (mapsApi, objectName, ...args) => {
      const factory = mapsApi && mapsApi[objectName];
      if (typeof factory !== "function") {
        throw new Error(`Tencent Map API missing constructor: ${objectName}`);
      }
      try {
        return new factory(...args);
      } catch (error) {
        if (error && typeof error.message === "string" && error.message.includes("is not a constructor")) {
          return factory(...args);
        }
        throw error;
      }
    };
    const createPolyline = (path, color, mapsApi, dashed = false) => {
      const polyline = createMapsObject(mapsApi, "Polyline", {
        map,
        path,
        strokeColor: color,
        strokeWeight: 4,
        strokeDashStyle: dashed ? "dash" : "solid"
      });
      routeOverlays.push(polyline);
      return polyline;
    };
    const md5 = string => {
      function md5Cycle(x, k) {
        let [a, b, c, d] = x;
        a = ff(a, b, c, d, k[0], 7, -680876936);
        d = ff(d, a, b, c, k[1], 12, -389564586);
        c = ff(c, d, a, b, k[2], 17, 606105819);
        b = ff(b, c, d, a, k[3], 22, -1044525330);
        a = ff(a, b, c, d, k[4], 7, -176418897);
        d = ff(d, a, b, c, k[5], 12, 1200080426);
        c = ff(c, d, a, b, k[6], 17, -1473231341);
        b = ff(b, c, d, a, k[7], 22, -45705983);
        a = ff(a, b, c, d, k[8], 7, 1770035416);
        d = ff(d, a, b, c, k[9], 12, -1958414417);
        c = ff(c, d, a, b, k[10], 17, -42063);
        b = ff(b, c, d, a, k[11], 22, -1990404162);
        a = ff(a, b, c, d, k[12], 7, 1804603682);
        d = ff(d, a, b, c, k[13], 12, -40341101);
        c = ff(c, d, a, b, k[14], 17, -1502002290);
        b = ff(b, c, d, a, k[15], 22, 1236535329);
        a = gg(a, b, c, d, k[1], 5, -165796510);
        d = gg(d, a, b, c, k[6], 9, -1069501632);
        c = gg(c, d, a, b, k[11], 14, 643717713);
        b = gg(b, c, d, a, k[0], 20, -373897302);
        a = gg(a, b, c, d, k[5], 5, -701558691);
        d = gg(d, a, b, c, k[10], 9, 38016083);
        c = gg(c, d, a, b, k[15], 14, -660478335);
        b = gg(b, c, d, a, k[4], 20, -405537848);
        a = gg(a, b, c, d, k[9], 5, 568446438);
        d = gg(d, a, b, c, k[14], 9, -1019803690);
        c = gg(c, d, a, b, k[3], 14, -187363961);
        b = gg(b, c, d, a, k[8], 20, 1163531501);
        a = gg(a, b, c, d, k[13], 5, -1444681467);
        d = gg(d, a, b, c, k[2], 9, -51403784);
        c = gg(c, d, a, b, k[7], 14, 1735328473);
        b = gg(b, c, d, a, k[12], 20, -1926607734);
        a = hh(a, b, c, d, k[5], 4, -378558);
        d = hh(d, a, b, c, k[8], 11, -2022574463);
        c = hh(c, d, a, b, k[11], 16, 1839030562);
        b = hh(b, c, d, a, k[14], 23, -35309556);
        a = hh(a, b, c, d, k[1], 4, -1530992060);
        d = hh(d, a, b, c, k[4], 11, 1272893353);
        c = hh(c, d, a, b, k[7], 16, -155497632);
        b = hh(b, c, d, a, k[10], 23, -1094730640);
        a = hh(a, b, c, d, k[13], 4, 681279174);
        d = hh(d, a, b, c, k[0], 11, -358537222);
        c = hh(c, d, a, b, k[3], 16, -722521979);
        b = hh(b, c, d, a, k[6], 23, 76029189);
        a = hh(a, b, c, d, k[9], 4, -640364487);
        d = hh(d, a, b, c, k[12], 11, -421815835);
        c = hh(c, d, a, b, k[15], 16, 530742520);
        b = hh(b, c, d, a, k[2], 23, -995338651);
        a = ii(a, b, c, d, k[0], 6, -198630844);
        d = ii(d, a, b, c, k[7], 10, 1126891415);
        c = ii(c, d, a, b, k[14], 15, -1416354905);
        b = ii(b, c, d, a, k[5], 21, -57434055);
        a = ii(a, b, c, d, k[12], 6, 1700485571);
        d = ii(d, a, b, c, k[3], 10, -1894986606);
        c = ii(c, d, a, b, k[10], 15, -1051523);
        b = ii(b, c, d, a, k[1], 21, -2054922799);
        a = ii(a, b, c, d, k[8], 6, 1873313359);
        d = ii(d, a, b, c, k[15], 10, -30611744);
        c = ii(c, d, a, b, k[6], 15, -1560198380);
        b = ii(b, c, d, a, k[13], 21, 1309151649);
        a = ii(a, b, c, d, k[4], 6, -145523070);
        d = ii(d, a, b, c, k[11], 10, -1120210379);
        c = ii(c, d, a, b, k[2], 15, 718787259);
        b = ii(b, c, d, a, k[9], 21, -343485551);
        x[0] = add32(a, x[0]);
        x[1] = add32(b, x[1]);
        x[2] = add32(c, x[2]);
        x[3] = add32(d, x[3]);
      }
      function cmn(q, a, b, x, s, t) {
        a = add32(add32(a, q), add32(x, t));
        return add32(a << s | a >>> 32 - s, b);
      }
      function ff(a, b, c, d, x, s, t) {
        return cmn(b & c | ~b & d, a, b, x, s, t);
      }
      function gg(a, b, c, d, x, s, t) {
        return cmn(b & d | c & ~d, a, b, x, s, t);
      }
      function hh(a, b, c, d, x, s, t) {
        return cmn(b ^ c ^ d, a, b, x, s, t);
      }
      function ii(a, b, c, d, x, s, t) {
        return cmn(c ^ (b | ~d), a, b, x, s, t);
      }
      function md51(s) {
        const txt = "";
        const n = s.length;
        const state = [1732584193, -271733879, -1732584194, 271733878];
        let i;
        for (i = 64; i <= n; i += 64) {
          md5Cycle(state, md5blk(s.substring(i - 64, i)));
        }
        s = s.substring(i - 64);
        const tail = new Array(16).fill(0);
        for (i = 0; i < s.length; i += 1) {
          tail[i >> 2] |= s.charCodeAt(i) << (i % 4 << 3);
        }
        tail[i >> 2] |= 0x80 << (i % 4 << 3);
        if (i > 55) {
          md5Cycle(state, tail);
          for (i = 0; i < 16; i += 1) {
            tail[i] = 0;
          }
        }
        tail[14] = n * 8;
        md5Cycle(state, tail);
        return state;
      }
      function md5blk(s) {
        const md5blks = [];
        for (let i = 0; i < 64; i += 4) {
          md5blks[i >> 2] = s.charCodeAt(i) + (s.charCodeAt(i + 1) << 8) + (s.charCodeAt(i + 2) << 16) + (s.charCodeAt(i + 3) << 24);
        }
        return md5blks;
      }
      function rhex(n) {
        const hexChr = "0123456789abcdef";
        let str = "";
        for (let j = 0; j < 4; j += 1) {
          str += hexChr.charAt(n >> j * 8 + 4 & 0x0f) + hexChr.charAt(n >> j * 8 & 0x0f);
        }
        return str;
      }
      function hex(x) {
        return x.map(rhex).join("");
      }
      function add32(a, b) {
        return a + b & 0xffffffff;
      }
      return hex(md51(string));
    };
    const buildTencentSortedQuery = params => {
      return Object.keys(params).sort().map(key => `${key}=${params[key]}`).join("&");
    };
    const buildTencentEncodedQuery = params => {
      return Object.keys(params).map(key => `${key}=${encodeURIComponent(params[key])}`).join("&");
    };
    const decodeTencentPolyline = (polyline, mapsApi) => {
      if (!Array.isArray(polyline) || polyline.length < 2) {
        return [];
      }
      const decoded = polyline.slice();
      for (let i = 2; i < decoded.length; i += 2) {
        decoded[i] = decoded[i - 2] + decoded[i] / 1000000;
        decoded[i + 1] = decoded[i - 1] + decoded[i + 1] / 1000000;
      }
      const path = [];
      for (let i = 0; i < decoded.length; i += 2) {
        path.push(createMapsObject(mapsApi, "LatLng", decoded[i], decoded[i + 1]));
      }
      return path;
    };
    const requestTencentDrivingRoute = async (from, to) => {
      const routeParams = {
        from,
        key: TENCENT_MAP_KEY,
        output: "json",
        to
      };
      const sortedQuery = buildTencentSortedQuery(routeParams);
      const sig = md5(`${TENCENT_ROUTE_PATH}?${sortedQuery}${TENCENT_MAP_SK}`);
      const requestQuery = buildTencentEncodedQuery({
        ...routeParams,
        sig
      });
      const response = await fetch(`${TENCENT_ROUTE_PROXY_PREFIX}${TENCENT_ROUTE_PATH}?${requestQuery}`);
      if (!response.ok) {
        throw new Error(`Tencent route request failed with status ${response.status}`);
      }
      const result = await response.json();
      if (!result || result.status !== 0 || !result.result || !Array.isArray(result.result.routes) || result.result.routes.length === 0) {
        throw new Error(`Tencent route response error: ${result ? result.status : "unknown"} ${result && result.message ? result.message : ""}`.trim());
      }
      return result.result.routes[0];
    };
    const notifyTencentRouteFallback = error => {
      const message = error && typeof error.message === "string" ? error.message : String(error || "");
      const isQuotaExceeded = message.includes("Tencent route response error: 121") || message.includes("此key每日调用量已达到上限");
      ElNotification({
        title: t("installConvey.map"),
        message: isQuotaExceeded ? locale.value === "zh" ? "腾讯路线规划接口当日调用量已达上限，当前仅能回退显示首尾轨迹直线。" : "Tencent route planning quota has been reached for today, so the map falls back to a straight line between track endpoints." : locale.value === "zh" ? "腾讯路线规划失败，当前仅回退显示首尾轨迹直线。" : "Tencent route planning failed, so the map falls back to a straight line between track endpoints.",
        type: "warning",
        duration: 5000
      });
    };
    const fitMapToPath = (path, mapsApi) => {
      if (!map || !Array.isArray(path) || path.length === 0) {
        return;
      }
      const bounds = createMapsObject(mapsApi, "LatLngBounds");
      path.forEach(point => {
        bounds.extend(point);
      });
      map.fitBounds(bounds);
    };
    const drawRoute = (path, express, mapsApi, waypoints) => {
      if (path.length === 0) {
        return;
      }
      const startMarker = createMapsObject(mapsApi, "Marker", {
        map,
        position: path[0]
      });
      routeOverlays.push(startMarker);
      const transporterIcon = createMapsObject(mapsApi, "MarkerImage", "https://aqualpublic.oss-cn-shanghai.aliyuncs.com/weapp/transporter%202.png", createMapsObject(mapsApi, "Size", 60, 30), createMapsObject(mapsApi, "Point", 0, 0), createMapsObject(mapsApi, "Point", 30, 15));
      const currentMarker = createMapsObject(mapsApi, "Marker", {
        map,
        position: waypoints[waypoints.length - 1],
        icon: transporterIcon
      });
      routeOverlays.push(currentMarker);
      if (express.expressStateName == "已签收") {
        const endMarker = createMapsObject(mapsApi, "Marker", {
          map,
          position: path[path.length - 1]
        });
        routeOverlays.push(endMarker);
      }
      createPolyline(path, "#00f", mapsApi);
      fitMapToPath(path, mapsApi);
    };
    const handleVisible = () => {
      if (document.visibilityState === 'visible') {
        console.log('页面重新激活');
        let data = {
          installationResultId: installQuery.insSelect.installationResultId,
          installationStatusId: installQuery.insSelect.installationStatusId,
          searchKeyword: installQuery.insValue,
          activityId: installQuery.insSelect.activityId,
          storeType: installQuery.insSelect.storeType,
          vendorId: installQuery.insSelect.vendorId,
          vendorTypeId: installQuery.insSelect.vendorTypeId,
          installationConfirmStatusId: installQuery.insSelect.installationConfirmStatusId
        };
        if (Array.isArray(installQuery.insSelect.provinceCity)) {
          data.province = installQuery.insSelect.provinceCity[0];
          if (installQuery.insSelect.provinceCity.length > 1) {
            data.city = installQuery.insSelect.provinceCity[1];
          }
        }
        const $table = installTable.value;
        $table.clearCheckboxRow();
        $table.clearCheckboxReserve();
        reportChecks.value.length = 0;
        deliveredControl.isOpenReport = false;
        console.log(data);
        getInstallationPageApi(data, installPaginationData.currentPage, installPaginationData.pageSize);
      }
    };
    onMounted(async () => {
      document.addEventListener('visibilitychange', handleVisible);
      let windowWidth = window.innerWidth;
      console.log(windowWidth);
      if (windowWidth <= 768) {
        installPaginationData.pageSize = 20;
        conveyPaginationData.pageSize = 20;
      }
      if (vendorId) {
        installQuery.insSelect.vendorId = parseInt(vendorId);
        conveyQuery.insSelect.vendorId = parseInt(vendorId);
      }
      if (activityId) {
        installQuery.insSelect.activityId = parseInt(activityId);
        conveyQuery.insSelect.activityId = parseInt(activityId);
      }
      const installationPageParam = window.localStorage.getItem("installation_page_param");
      if (installationPageParam != null) {
        let param = JSON.parse(installationPageParam);
        if (param.data.vendorId === installQuery.insSelect.vendorId && param.data.activityId === installQuery.insSelect.activityId) {
          installQuery.insValue = param.data.searchKeyword;
          installQuery.insSelect.installationResultId = param.data.installationResultId;
          installQuery.insSelect.installationStatusId = param.data.installationStatusId;
          installQuery.insSelect.activityId = param.data.activityId;
          installQuery.insSelect.storeType = param.data.storeType;
          installQuery.insSelect.vendorId = param.data.vendorId;
          installQuery.insSelect.vendorTypeId = param.data.vendorTypeId;
          installQuery.insSelect.installationConfirmStatusId = param.data.installationConfirmStatusId;
          if (param.data.province != null) {
            installQuery.insSelect.provinceCity = [param.data.province];
            if (param.data.city != null) {
              installQuery.insSelect.provinceCity.push(param.data.city);
            }
          }
          installPaginationData.currentPage = param.pageIndex;
          installPaginationData.pageSize = param.pageSize;
          getInstallationPageApi(param.data, param.pageIndex, param.pageSize);
        } else {
          getInstallationPageApi({
            vendorId: installQuery.insSelect.vendorId,
            activityId: installQuery.insSelect.activityId
          }, installPaginationData.currentPage, installPaginationData.pageSize);
        }
      } else {
        getInstallationPageApi({
          vendorId: installQuery.insSelect.vendorId,
          activityId: installQuery.insSelect.activityId
        }, installPaginationData.currentPage, installPaginationData.pageSize);
      }
      getLogisticsPageApi({
        searchKeyword: conveyQuery.insValue,
        activityId: conveyQuery.insSelect.activityId,
        storeTypeId: conveyQuery.insSelect.storeType,
        vendorId: conveyQuery.insSelect.vendorId,
        city: conveyQuery.insSelect.areaInput,
        logisticsTypeId: conveyQuery.insSelect.logisticsTypeId,
        expressStateCode: conveyQuery.insSelect.state
      }, conveyPaginationData.currentPage, conveyPaginationData.pageSize);
      // 获取活动相关所有店铺
      let cityList = await getStoreCity({
        activityId: activityId,
        storeTypeId: conveyQuery.insSelect.storeType
      });
      if (cityList == null) {
        return;
      }
      cityData.push(...cityList);
      // 获取活动相关所有省份
      let storeActivityVendorRO = {
        activityId: installQuery.insSelect.activityId,
        vendorId: installQuery.insSelect.vendorId,
        storeTypeId: installQuery.insSelect.storeType
      };
      if (Array.isArray(installQuery.insSelect.provinceCity)) {
        storeActivityVendorRO.province = installQuery.insSelect.provinceCity[0];
        if (installQuery.insSelect.provinceCity.length > 1) {
          storeActivityVendorRO.city = installQuery.insSelect.provinceCity[1];
        }
      }
      var provinceDictList = await getProvinceDict(storeActivityVendorRO);
      if (provinceDictList == null) {
        return;
      } else {
        provinceDictList = provinceDictList.map(provinceItem => ({
          value: provinceItem.province,
          label: provinceItem.province,
          children: provinceItem.cities.map(cityItem => ({
            value: cityItem.city,
            label: cityItem.city
          }))
        }));
      }
      provinceDictData.push(...provinceDictList);
      // 获取所有活动
      let activityList = await selectAllActivity();
      if (activityList == null) {
        return;
      }
      let findIndex = activityList.findIndex(element => element.activityId == activityId);
      if (findIndex != -1) {
        store.commit("setHeaderTitle", activityList[findIndex].activityName);
      }
      activityData.push(...activityList);
      // // 获取所有店铺类型
      // let storeTypeList = await getStoreType();
      // if (storeTypeList == null) {
      //   return;
      // }
      // storeTypeData.push(...storeTypeList);
      // 获取指定活动安装所有店铺类型
      let storeTypeInstallationList = await getStoreTypeByInstallation(storeActivityVendorRO);
      if (storeTypeInstallationList == null) {
        return;
      }
      storeTypeInstallationData.push(...storeTypeInstallationList);
      // 获取指定活动物流所有店铺类型
      let logisticsStoreActivityVendorRO = {
        activityId: conveyQuery.insSelect.activityId,
        vendorId: conveyQuery.insSelect.vendorId
      };
      let storeTypeLogisticsList = await getStoreTypeByLogistics(logisticsStoreActivityVendorRO);
      if (storeTypeLogisticsList == null) {
        return;
      }
      storeTypeLogisticsData.push(...storeTypeLogisticsList);
      // 获取所有供应商
      let vendorList = await getVendor();
      if (vendorList == null) {
        return;
      }
      vendorData.push(...vendorList);
      // 获取所有供应商类型
      let vendorTypeList = await getVendorType();
      if (vendorTypeList == null) {
        return;
      }
      vendorTypeData.push(...vendorTypeList);
      // 获取所有安装状态
      let installationStatusList = await getInstallationStatus();
      if (installationStatusList == null) {
        return;
      }
      installationStatusData.push(...installationStatusList);
      // 获取所有验收状态
      let getInstallationConfirmList = await getInstallationConfirm();
      if (getInstallationConfirmList == null) {
        return;
      }
      getInstallationConfirmData.push(...getInstallationConfirmList);
      // 获取所有物流状态
      let getExpressStateList = await getExpressState();
      if (getExpressStateList == null) {
        return;
      }
      for (let i = 0; i < getExpressStateList.length; i++) {
        if (parseInt(getExpressStateList[i].expressStateId) <= 10) {
          expressStateListData.push(getExpressStateList[i]);
        }
      }
      // expressStateListData.push(...getExpressStateList);
      // 获取所有物流类型
      let getLogisticsTypeList = await getLogisticsType();
      if (getLogisticsTypeList == null) {
        return;
      }
      logisticsTypeData.push(...getLogisticsTypeList);

      //////////地图
      loadTencentMapSdk().then(mapsApi => {
        qqMaps = mapsApi;
      }).catch(e => {
        console.log(e);
      });
    });
    onBeforeUnmount(() => {
      document.removeEventListener('visibilitychange', handleVisible);
      destroyExpressMap();
    });
    onUnmounted(() => {});
    const expressInfoOpen = ref(false);
    const currentExpress = ref(null);
    const onExpressInfoOpen = row => {
      currentExpress.value = row;
      expressInfoOpen.value = true;
      if (Array.isArray(row.expressCoordinates) && row.expressCoordinates.length > 0) {
        initExpressMap(row, true);
      }
    };
    const onExpressInfoClose = () => {
      currentExpress.value = null;
      expressInfoOpen.value = false;
      initExpressMap(false);
    };
    const initExpressMap = async (express, visible) => {
      if (visible === true) {
        await nextTick();
        const mapsApi = qqMaps || (await loadTencentMapSdk());
        destroyExpressMap();
        const container = document.getElementById("container");
        if (!container) {
          return;
        }
        map = createMapsObject(mapsApi, "Map", container, {
          zoom: 10,
          center: createMapsObject(mapsApi, "LatLng", 23.15815, 112.56706)
        });
        const senderPoint = parseCoordinateToLatLng(express.senderCityLatAndLng, mapsApi);
        const receiverPoint = parseCoordinateToLatLng(express.receiverCityLatAndLng, mapsApi);
        const waypoints = express.expressCoordinates.map(item => parseCoordinateToLatLng(item.latAndLng, mapsApi)).filter(Boolean);
        if (waypoints.length === 0) {
          if (senderPoint) {
            map.setCenter(senderPoint);
          } else if (receiverPoint) {
            map.setCenter(receiverPoint);
          }
          return;
        }
        if (waypoints.length === 1) {
          const singleMarker = createMapsObject(mapsApi, "Marker", {
            map,
            position: waypoints[0]
          });
          routeOverlays.push(singleMarker);
          map.setCenter(waypoints[0]);
          return;
        }
        try {
          const firstCoordinate = express.expressCoordinates[0].latAndLng;
          const lastCoordinate = express.expressCoordinates[express.expressCoordinates.length - 1].latAndLng;
          const routeResult = await requestTencentDrivingRoute(firstCoordinate, lastCoordinate);
          const routePath = decodeTencentPolyline(routeResult.polyline, mapsApi);
          if (routePath.length > 0) {
            drawRoute(routePath, express, mapsApi, waypoints);
            return;
          }
        } catch (error) {
          console.warn("Tencent route planning failed, fallback to waypoint polyline", error);
          notifyTencentRouteFallback(error);
        }
        createPolyline(waypoints, "#00f", mapsApi);
        fitMapToPath(waypoints, mapsApi);
      } else {
        destroyExpressMap();
      }
    };
    const expandConfig = {
      visibleMethod({
        row
      }) {
        if (row.storeLocations.length == 0) {
          return false;
        }
        return true;
      }
    };

    // const installUploadClick = (row) => {
    //   if (vendorId == "" && tokenData.type === 1) {
    //     router.push({
    //       path: "/store-location/" + row.storeCode + '/' + 0,
    //       query: { activityId: activityId },
    //     });
    //   } else {
    //     router.push({
    //       path: "/store-location/" + row.storeCode + '/' + 0,
    //       query: { installationId: row.installationId },
    //     });
    //   }
    // };
    const installUploadClick = row => {
      let url = "";
      if (vendorId == "" && tokenData.type === 1) {
        url = "/store-location/" + row.storeCode + "/" + 0 + `?activityId=${activityId}`;
      } else {
        url = "/store-location/" + row.storeCode + "/" + 0 + `?installationId=${row.installationId}`;
      }

      // 新窗口打开
      window.open(url, "_blank");
    };

    //convey
    const uploadConverPane = ref(null);
    const conveyTable = ref();

    // 分页
    const conveyPaginationData = reactive({
      pageSizes: [25, 50, 100],
      currentPage: 1,
      totalSize: 0,
      pageSize: 25
    });
    // 安装进度列表
    const conveyData = reactive({
      data: []
    });
    const expressStateListData = reactive([]);
    const logisticsTypeData = reactive([]);
    const uploadConverData = reactive({
      signatureData: {
        accessId: null,
        policy: null,
        signature: null,
        dir: null,
        host: "",
        expire: null,
        uuid: null
      },
      fileList: [],
      data: {},
      lastUpload: {},
      cacheData: []
    });
    const uploadConverPopoverVisible = ref(false);
    const conveyQuery = reactive({
      typeIndex: 1,
      insValue: "",
      insSelect: {
        storeType: null,
        vendorId: null,
        logisticsTypeId: null,
        state: null,
        areaInput: null
      }
    });
    //分页Select变化
    const paginationSizeConverChange = val => {
      let data = {
        searchKeyword: conveyQuery.insValue,
        activityId: conveyQuery.insSelect.activityId,
        storeTypeId: conveyQuery.insSelect.storeType,
        vendorId: conveyQuery.insSelect.vendorId,
        city: conveyQuery.insSelect.areaInput,
        logisticsTypeId: conveyQuery.insSelect.logisticsTypeId,
        expressStateCode: conveyQuery.insSelect.state
      };
      getLogisticsPageApi(data, conveyPaginationData.currentPage, conveyPaginationData.pageSize);
    };
    //分页页数变化
    const paginationCurrentConverChange = val => {
      let data = {
        searchKeyword: conveyQuery.insValue,
        activityId: conveyQuery.insSelect.activityId,
        storeTypeId: conveyQuery.insSelect.storeType,
        vendorId: conveyQuery.insSelect.vendorId,
        city: conveyQuery.insSelect.areaInput,
        logisticsTypeId: conveyQuery.insSelect.logisticsTypeId,
        expressStateCode: conveyQuery.insSelect.state
      };
      getLogisticsPageApi(data, conveyPaginationData.currentPage, conveyPaginationData.pageSize);
    };

    //btn点击事件
    const openUploadConverPopover = () => {
      uploadConverPane.value.clearFiles();
      uploadConverPopoverVisible.value = true;
    };
    //当超出限制时，执行的钩子函数
    const handleConverExceed = files => {
      uploadConverPane.value.clearFiles();
      const file = files[0];
      file.uid = genFileId();
      uploadConverPane.value.handleStart(file);
      uploadConverPane.value.submit();
    };

    //上传文件之前的钩子
    const handleConverBeforeUpload = async file => {
      uploadConverData.signatureData = await getSignature("__temporary");
      let filename = file.name;
      let fullName = uploadConverData.signatureData.uuid + util.getSuffix(filename);
      let keyValue = uploadConverData.signatureData.dir + fullName;
      uploadConverData.data = {
        name: file.name,
        key: keyValue,
        policy: uploadConverData.signatureData.policy,
        OSSAccessKeyId: uploadConverData.signatureData.accessId,
        signature: uploadConverData.signatureData.signature,
        success_action_status: "200",
        onSuccess: file.uid
      };
      uploadConverData.lastUpload = {
        uid: file.uid,
        filename: fullName
      };
    };
    //文件上传成功的钩子
    const handleConverOnSuccess = async (response, file, files) => {
      if (file.status === "success") {
        const activityUploadedRO = {
          activityId: activityId,
          uploadedRO: {
            fileName: uploadConverData.data.name,
            uploadedName: uploadConverData.data.key
          }
        };
        importConverRequest(activityUploadedRO);
      }
    };
    const importConverRequest = async activityUploadedRO => {
      const loadingInstance = ElLoading.service({
        lock: true,
        text: t("installConvey.uploadSuccess"),
        background: "rgba(0, 0, 0, 0.7)"
      });
      proxy.$api.scheduleRequest.importLogistics(activityUploadedRO).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "202261") {
            uploadConverPopoverVisible.value = false;
            ElNotification({
              title: "success",
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "success",
              duration: 3000
            });
          } else if (res.result.dataCode === "202266") {
            uploadConverPopoverVisible.value = false;
            importMessage.importMessageVisible = true;
            importMessage.importMessages = res.result.data;
          } else {
            ElNotification({
              title: t("installConvey.failure"),
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "error",
              duration: 6000
            });
          }
        } else {
          ElNotification({
            title: t("installConvey.failure"),
            message: res.msg,
            type: "error",
            duration: 6000
          });
        }
        nextTick(() => {
          loadingInstance.close();
        });
      }).catch(error => {
        if (error.code == "TOKEN_MISSING") {
          resolve(null);
        } else {
          ElNotification({
            title: "error",
            message: error,
            type: "error",
            duration: 3000
          });
        }
        nextTick(() => {
          loadingInstance.close();
        });
      });
    };
    const conveyLoading = ref(false);

    //表头排序
    const headerCellConverClickEvent = ({
      column,
      triggerResizable,
      triggerSort,
      triggerFilter
    }) => {
      const $table = conveyTable.value;
      if ($table) {
        // 如果触发了列的其他功能按钮
        if (column.sortable && !(triggerResizable || triggerSort || triggerFilter)) {
          if (column.order === "desc") {
            $table.clearSort();
          } else if (column.order === "asc") {
            $table.sort(column.field, "desc");
          } else {
            $table.sort(column.field, "asc");
          }
        }
      }
    };
    //获取发货进度列表
    const getLogisticsPageApi = async (data, pageIndex, pageSize, add) => {
      conveyLoading.value = true;
      let logisticsPageRO = {
        data: data,
        pageIndex: pageIndex,
        pageSize: pageSize
      };
      proxy.$api.scheduleRequest.getLogisticsPage(logisticsPageRO).then(res => {
        console.log(res);
        if (res.code === "200000") {
          if (res.result.dataCode === "202250") {
            let msg = res.result.data.pageList;
            if (msg) {
              if (add) {
                conveyData.data.push(...msg);
                conveyPaginationData.totalSize = res.result.data.totalCount;
              } else {
                conveyData.data = msg;
                conveyPaginationData.totalSize = res.result.data.totalCount;
              }
            } else {
              conveyData.data.length = 0;
              conveyPaginationData.totalSize = res.result.data.totalCount;
            }
            deliveredControl.isOpenBatch = false;
          } else {
            ElNotification({
              title: t("installConvey.failure"),
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "error",
              duration: 3000
            });
          }
        } else {
          ElNotification({
            title: t("installConvey.failure"),
            message: res.msg,
            type: "error",
            duration: 3000
          });
        }
        conveyLoading.value = false;
      }).catch(error => {
        if (error.code == "TOKEN_MISSING") {
          console.log(error);
        } else {
          ElNotification({
            title: t("installConvey.failure"),
            message: error,
            type: "error",
            duration: 3000
          });
        }
        conveyLoading.value = false;
      });
    };

    // 获取所有物流状态
    const getExpressState = async () => {
      return new Promise((resolve, reject) => {
        proxy.$api.scheduleRequest.getExpressState(true).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: t("installConvey.failure"),
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };

    // 获取所有确认状态
    const getLogisticsType = async () => {
      return new Promise((resolve, reject) => {
        proxy.$api.scheduleRequest.getLogisticsType(true).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: t("installConvey.failure"),
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };

    //搜索点击事件
    const searchConverClick = async linkageType => {
      if (linkageType === 1) {
        cityData.length = 0;
        // 获取活动相关所有店铺
        let cityList = await getStoreCity({
          activityId: activityId,
          storeTypeId: conveyQuery.insSelect.storeType
        });
        if (cityList == null) {
          return;
        }
        cityData.push(...cityList);
      } else if (linkageType === 2) {
        let logisticsStoreActivityVendorRO = {
          activityId: conveyQuery.insSelect.activityId,
          vendorId: conveyQuery.insSelect.vendorId,
          storeTypeId: conveyQuery.insSelect.storeType,
          city: conveyQuery.insSelect.areaInput
        };
        storeTypeLogisticsData.length = 0;
        let storeTypeLogisticsList = await getStoreTypeByLogistics(logisticsStoreActivityVendorRO);
        if (storeTypeLogisticsList == null) {
          return;
        }
        storeTypeLogisticsData.push(...storeTypeLogisticsList);
      }
      let data = {
        searchKeyword: conveyQuery.insValue,
        activityId: conveyQuery.insSelect.activityId,
        storeTypeId: conveyQuery.insSelect.storeType,
        vendorId: conveyQuery.insSelect.vendorId,
        city: conveyQuery.insSelect.areaInput,
        logisticsTypeId: conveyQuery.insSelect.logisticsTypeId,
        expressStateCode: conveyQuery.insSelect.state
      };
      getLogisticsPageApi(data, 1, conveyPaginationData.pageSize);
    };

    //导出
    const openExportEvent = () => {
      let logisticsPageRO = {
        searchKeyword: conveyQuery.insValue,
        activityId: conveyQuery.insSelect.activityId,
        storeTypeId: conveyQuery.insSelect.storeType,
        vendorId: conveyQuery.insSelect.vendorId,
        city: conveyQuery.insSelect.areaInput,
        logisticsTypeId: conveyQuery.insSelect.logisticsTypeId,
        expressStateId: conveyQuery.insSelect.state
      };
      getLogisticsListExport(logisticsPageRO);
    };
    const getLogisticsListExport = logisticsPageRO => {
      const loadingInstance = ElLoading.service({
        lock: true,
        text: t("installConvey.exportingTemplate"),
        background: "rgba(0, 0, 0, 0.7)"
      });
      proxy.$api.scheduleRequest.getLogisticsListExport(logisticsPageRO).then(res => {
        nextTick(() => {
          loadingInstance.close();
        });
      }).catch(error => {
        ElNotification({
          title: "error",
          message: error,
          type: "error",
          duration: 3000
        });
        nextTick(() => {
          loadingInstance.close();
        });
      });
    };
    const conveyTableScroll = ({
      type,
      scrollTop,
      scrollLeft,
      scrollHeight,
      scrollWidth,
      bodyWidth,
      bodyHeight,
      isX,
      isY,
      $event
    }) => {
      let mediaQuery = window.matchMedia("(max-width: 768px)");
      if (mediaQuery.matches) {
        if (scrollTop + bodyHeight >= scrollHeight - 20) {
          let totalCount = Math.ceil(conveyPaginationData.totalSize / conveyPaginationData.pageSize);
          console.log("-------------------" + conveyPaginationData.currentPage < totalCount);
          if (conveyPaginationData.currentPage < totalCount) {
            console.log("翻页");
            conveyPaginationData.currentPage++;
            let data = {
              searchKeyword: conveyQuery.insValue,
              activityId: conveyQuery.insSelect.activityId,
              storeTypeId: conveyQuery.insSelect.storeType,
              vendorId: conveyQuery.insSelect.vendorId,
              city: conveyQuery.insSelect.areaInput,
              logisticsTypeId: conveyQuery.insSelect.logisticsTypeId,
              expressStateCode: conveyQuery.insSelect.state
            };
            getLogisticsPageApi(data, conveyPaginationData.currentPage, conveyPaginationData.pageSize, "add");
          }
        }
      }
    };
    const batchDeliveredLogistics = () => {
      if (deliveredControl.isOpenBatch == false) {
        deliveredControl.isOpenBatch = true;
      } else {
        const $table = conveyTable.value;
        if ($table) {
          const selectRecords = $table.getCheckboxRecords();
          let checkRecords = [];
          for (let logistics of selectRecords) {
            if (logistics.expressStateName !== "已签收" && logistics.logisticsTypeId !== 1) {
              checkRecords.push(logistics);
            }
          }
          if (checkRecords.length > 0) {
            ElMessageBox.confirm(t("installConvey.confirmDeliveryPrompt"), t("installConvey.ask"), {
              confirmButtonText: t("installConvey.confirm"),
              cancelButtonText: t("installConvey.cancel"),
              type: "warning"
            }).then(() => {
              batchDeliveredLogisticsRequest(checkRecords);
            }).catch(() => {
              ElMessage({
                type: "info",
                message: t("installConvey.cancelDelete")
              });
            });
          } else {
            if ($table) {
              $table.clearCheckboxRow();
            }
            deliveredControl.isOpenBatch = false;
          }
        }
      }
    };
    const deliveredLogistics = row => {
      ElMessageBox.confirm(t("installConvey.confirmDeliveryPrompt"), t("installConvey.ask"), {
        confirmButtonText: t("installConvey.confirm"),
        cancelButtonText: t("installConvey.cancel"),
        type: "warning"
      }).then(() => {
        deliveredLogisticsRequest(row);
      }).catch(() => {
        ElMessage({
          type: "info",
          message: t("installConvey.cancelDelete")
        });
      });
    };
    const selfActivityInstallation = (row, subRow) => {
      const activityInstallationSelfRO = {
        activityInstallationId: subRow.activityInstallationId
      };
      ElMessageBox.confirm(t("installConvey.confirmSelfInstall"), t("installConvey.ask"), {
        confirmButtonText: t("installConvey.confirm"),
        cancelButtonText: t("installConvey.cancel"),
        type: "warning"
      }).then(() => {
        selfActivityInstallationRequest(activityInstallationSelfRO, row);
      }).catch(() => {
        ElMessage({
          type: "info",
          message: t("installConvey.cancelDelete")
        });
      });
    };
    const selfActivityInstallationRequest = async (activityInstallationSelfRO, row) => {
      proxy.$api.scheduleRequest.selfActivityInstallation(activityInstallationSelfRO).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "202267") {
            installationData.data.map(installation => {
              if (installation.installationId === row.installationId) {
                Object.assign(installation, res.result.data);
              }
              return installation;
            });
            installationData.data.filt;
            row = res.result.data;
            ElNotification({
              title: "success",
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "success",
              duration: 3000
            });
          } else {
            ElNotification({
              title: t("installConvey.failure"),
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "error",
              duration: 6000
            });
          }
        } else {
          ElNotification({
            title: t("installConvey.failure"),
            message: res.msg,
            type: "error",
            duration: 6000
          });
        }
      }).catch(error => {
        ElNotification({
          title: "error",
          message: error,
          type: "error",
          duration: 3000
        });
      });
    };
    const deliveredLogisticsRequest = async row => {
      proxy.$api.scheduleRequest.deliveredLogistics(row.logisticsId).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "202264") {
            ElNotification({
              title: "success",
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "success",
              duration: 3000
            });
            row.expressStateName = res.result.data.expressStateName;
            row.expressStateId = res.result.data.expressStateListData;
          } else {
            ElNotification({
              title: t("installConvey.failure"),
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "error",
              duration: 6000
            });
          }
        } else {
          ElNotification({
            title: t("installConvey.failure"),
            message: res.msg,
            type: "error",
            duration: 6000
          });
        }
      }).catch(error => {
        ElNotification({
          title: "error",
          message: error,
          type: "error",
          duration: 3000
        });
      });
    };
    const batchDeliveredLogisticsRequest = async rows => {
      let logisticsIds = [];
      for (let convery of rows) {
        logisticsIds.push(convery.logisticsId);
      }
      proxy.$api.scheduleRequest.batchDeliveredLogistics(logisticsIds).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "202264") {
            ElNotification({
              title: "success",
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "success",
              duration: 3000
            });
            for (let convery of rows) {
              convery.expressStateName = "已签收";
              convery.expressStateId = "3";
            }
            const $table = conveyTable.value;
            if ($table) {
              $table.clearCheckboxRow();
            }
            deliveredControl.isOpenBatch = false;
          } else {
            ElNotification({
              title: t("installConvey.failure"),
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "error",
              duration: 6000
            });
          }
        } else {
          ElNotification({
            title: t("installConvey.failure"),
            message: res.msg,
            type: "error",
            duration: 6000
          });
        }
      }).catch(error => {
        ElNotification({
          title: "error",
          message: error,
          type: "error",
          duration: 3000
        });
      });
    };
    const checkboxConfig = reactive({
      visibleMethod({
        row
      }) {
        return row.logisticsTypeId != 1 && row.expressStateName != "已签收";
      }
    });
    const rowClassName = row => {
      if (row.row.installationConfirmStatusId === 1) {
        return "borderLeftRed";
      } else if (row.row.installationConfirmStatusId === 2) {
        return "borderLeftYellow";
      } else {
        return "borderLeftGreen";
      }
    };
    const cityChange = value => {
      if (storeData.storePageRO.provinceCity) {
        storeData.storePageRO.provinceCity = value[value.length - 1];
      }
      getStoreByPageRequest(1, storeData.paginationData.pageSize, storeData.storePageRO);
    };
    return {
      installConveyData,
      importMessage,
      tokenData,
      activeName,
      permission,
      router,
      installQuery,
      activityData,
      installTable,
      installPaginationData,
      uploadInstallPane,
      uploadInstallPopoverVisible,
      uploadInstallData,
      installLoading,
      cityData,
      storeTypeData,
      vendorData,
      vendorTypeData,
      installationStatusData,
      getInstallationConfirmData,
      paginationSizeInstallChange,
      paginationCurrentInstallChange,
      openUploadInstallPopover,
      handleInstallExceed,
      handleInstallBeforeUpload,
      handleInstallOnSuccess,
      getDate,
      headerCellInstallClickEvent,
      searchInstallClick,
      copyStore,
      copyVendor,
      copyResult,
      installTableScroll,
      expandConfig,
      installUploadClick,
      goConveyPlan,
      activityId,
      vendorId,
      conveyQuery,
      conveyData,
      conveyTable,
      conveyPaginationData,
      uploadConverPane,
      uploadConverPopoverVisible,
      uploadConverData,
      conveyLoading,
      expressStateListData,
      logisticsTypeData,
      paginationSizeConverChange,
      paginationCurrentConverChange,
      openUploadConverPopover,
      handleConverExceed,
      handleConverBeforeUpload,
      handleConverOnSuccess,
      headerCellConverClickEvent,
      searchConverClick,
      openExportEvent,
      conveyTableScroll,
      deliveredLogistics,
      installationData,
      openInstallationEvent,
      batchDeliveredLogistics,
      deliveredControl,
      checkboxConfig,
      rowClassName,
      initExpressMap,
      onExpressInfoClose,
      expressInfoOpen,
      currentExpress,
      onExpressInfoOpen,
      map,
      qqMaps,
      provinceDictData,
      cityChange,
      storeTypeInstallationData,
      storeTypeLogisticsData,
      selfActivityInstallation,
      changeReport,
      reportChecks,
      onCheckboxChange,
      onCheckboxAll
    };
  }
};